import * as MuiStep from '@mui/material/Step'
import React from 'react'

export type StepProps = MuiStep.StepProps

export function Step({ children, ...props }: StepProps) {
  return <MuiStep.default {...props}>{children}</MuiStep.default>
}
